/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_SellerInputs */

const cs_clients_role_bound_seller = /** @type {(inputs: Clients_Role_Bound_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vlastnictví: nemovitosti, kde je klient prodávající/vlastník; kontext nabídky a provize.`)
};

const en_clients_role_bound_seller = /** @type {(inputs: Clients_Role_Bound_SellerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ownership: properties where this client is seller/owner; listing & commission context.`)
};

/**
* | output |
* | --- |
* | "Ownership: properties where this client is seller/owner; listing & commission context." |
*
* @param {Clients_Role_Bound_SellerInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_seller = /** @type {((inputs?: Clients_Role_Bound_SellerInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_SellerInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_seller(inputs)
	return cs_clients_role_bound_seller(inputs)
});